import Cookies from 'js-cookie'
import axios from 'axios'
var qs = require('qs') // 序列化参数

const TokenKey = 'x-AuthToken'
// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API + '/?s=', // api的base_url
  timeout: 15000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})
// 同步
export function getTokenSyn () {
  const tokenStr = window.localStorage.getItem('token')
  const tokenJson = JSON.parse(tokenStr)
  const postData = {
    AppID: process.env.APPID,
    Secret: process.env.secret,
    oldtoken: tokenJson ? tokenJson.token : ''
  }
  return service({
    url: process.env.BASE_API + '/?s=/Api/System/getToken',
    method: 'post',
    data: qs.stringify(postData)
  })
}

// 读取本地token
export function getToken () {
  const tokenStr = window.localStorage.getItem('token')
  const tokenJson = JSON.parse(tokenStr)
  const timestamp = Date.parse(new Date())
  if (tokenJson && (timestamp + 200000) < (tokenJson.time * 1000)) {
    // 存在有效token
    console.log('本地有效token')
    console.log(tokenJson)
    return tokenJson.token
  } else {
    // 校验token有效性
    const tokenStr = window.localStorage.getItem('token')
    const tokenJson = JSON.parse(tokenStr)
    const timestamp = Date.parse(new Date())
    if (tokenJson && timestamp + 200000 > tokenJson.time * 1000) {
      console.log('避免多个请求时 反复请求token')
      getTokenSyn()
        .then(res => {
          if (res.data.errorcode === 0) {
            // 处理数据
            const JsonObj = {
              token: res.data.data.token,
              time: res.data.data.expirestime
            }
            console.log(`获取成功${res.data.data.token}`)
            localStorage.setItem('token', JSON.stringify(JsonObj))
            if (res.data.data.islogin === 1) {
              localStorage.setItem('isLogin', true)
              localStorage.setItem('shareid', res.data.data.shareid)
            } else {
              localStorage.setItem('isLogin', false)
              localStorage.setItem('shareid', res.data.data.shareid)
            }
            console.log('获取成功，继续')
            return res.data.data.token
          } else {
            console.log('获取token错误')
          }
        })
        .catch(err => {
          console.log(err)
        })
    } else if (!tokenJson) {
      console.log(window.localStorage.getItem('token'))
      getTokenSyn()
        .then(res => {
          if (res.data.errorcode === 0) {
            // 处理数据
            const JsonObj = {
              token: res.data.data.token,
              time: res.data.data.expirestime
            }
            console.log(`获取成功${res.data.data.token}`)
            localStorage.setItem('token', JSON.stringify(JsonObj))
            if (res.data.data.islogin === 1) {
              localStorage.setItem('isLogin', true)
              localStorage.setItem('shareid', res.data.data.shareid)
            } else {
              localStorage.setItem('isLogin', false)
              localStorage.setItem('shareid', res.data.data.shareid)
            }
            console.log('获取成功，继续')
            return res.data.data.token
          } else {
            console.log('获取token错误')
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
export function setToken (token, days) {
  return Cookies.set(TokenKey, token, {
    expires: days
  })
}

// 退出登录移除所有本地记录 cookie localstrong等
export function removeData () {
  localStorage.removeItem('isLogin')
  localStorage.removeItem('accountIsLogin')
  localStorage.removeItem('beforeLoginUrl')
  localStorage.removeItem('ShoppingCarStr')
  localStorage.removeItem('shareid')
  localStorage.removeItem('showMenu')
  localStorage.removeItem('beforeLoginFullpath')
  localStorage.removeItem('beforeLoginPath')
  // localStorage.removeItem('token')
  // return true
}



// WEBPACK FOOTER //
// ./src/utils/auth.js